// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"11b2c3d3","172":"406884f7","450":"7365626b","540":"afed6c11"}[chunkId] + ".chunk.css";
};